import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=daf6addc&scoped=true"
import script from "./branch.vue?vue&type=script&lang=js"
export * from "./branch.vue?vue&type=script&lang=js"
import style0 from "./branch.vue?vue&type=style&index=0&id=daf6addc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf6addc",
  null
  
)

export default component.exports